<template>
  <div>
    <el-upload
      class="upload-image"
      accept=".png,.jpg,.jpeg"
      action=""
      :show-file-list="false"
      :http-request="httpRequest"
      :disabled="disabled"
    >
      <div class="upload-wrapper" :class="{ select: !disabled }">
        <div class="upload" v-if="!image">
          <i class="el-icon-plus"></i>
          <span>{{ text }}</span>
        </div>
        <div class="image" v-else>
          <img :src="image" alt="" />
          <div class="mask">
            <i class="el-icon-zoom-in" v-if="disabled" @click="dialogVisible = true"></i>
            <i class="el-icon-delete" v-if="!disabled" @click.stop="$emit('remove')"></i>
          </div>
        </div>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img :src="image" alt="" style="width: 100%;" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'uploadImage',
  props: {
    text: String,
    httpRequest: Function,
    image: String,
    disabled: false
  },
  data() {
    return {
      dialogVisible: false
    };
  }
};
</script>

<style lang="scss" scoped>
.upload-image {
  margin-right: 16px;

  /deep/.el-upload {
    display: block;
  }

  .upload-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 272px;
    height: 184px;
    border-radius: 4px;
    border: 1px solid #f2f2f2;

    &.select {
      &:hover {
        border-color: #bdbdbd;
      }
    }

    .upload {
      display: flex;
      flex-direction: column;
      color: #bfbfbf;
      font-size: 14px;

      i {
        font-size: 30px;
      }
    }

    .image {
      position: relative;
      width: 100%;
      height: 100%;

      &:hover {
        .mask {
          opacity: 1;
        }
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: fill;
      }

      .mask {
        display: flex;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        opacity: 0;
        background-color: rgba(0, 0, 0, 0.5);
        transition: 0.15s;

        i {
          font-size: 30px;
          color: #fff;
        }
      }
    }
  }
}
</style>
